/* eslint-disable operator-linebreak */
import Util from '@/assets/libs/util'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
import eventModule from '@/assets/libs/eventModule'
// let showMinPriceDifference
let minPrecMutexGroups
let minPrecComboCombo
let priceMounted
let difPriceMounted
let fullMinPriceMounted
let recalculateMinPrice = ''

const getMinPrice = function (prod) {
    let alreadyCalculatedMinPrice = prod.calculatedMinPrice != null
    let differentiatedPrices = DifferentiatedPricesController.getDiffPrices()
    if (alreadyCalculatedMinPrice && recalculateMinPrice === prod.recalculatedMinPrice) {
        return Util.formatMoney(prod.calculatedMinPriceDifferentiated)
    } else {
        eventModule.$emit('forceUpdate')
        return calculateMinPrice(prod, differentiatedPrices)
    }
}

const calculateMinPrice = function (prod) {
    initGlobalVariables()

    let isComboProduct = prod.productGroups && prod.productGroups.length > 0
    let productPrint = prod.productPrint === 'S'
    let differentiatedPrice = DifferentiatedPricesController.getDiffPrice(prod.productCode, false, prod)
    /* Verificar como funciona exatamente o applyInCombo */
    if (!isComboProduct || productPrint) {
        difPriceMounted += (differentiatedPrice || prod.price)
        priceMounted += prod.price
        fullMinPriceMounted += prod.fullPrice
    }

    let productHasGroups = prod.productGroups && prod.productGroups.length > 0
    if (productHasGroups) {
        treatGroupsMinPrices(prod)
        treatMutexGroupsMinPrices(prod)
    }
    prod.recalculatedMinPrice = recalculateMinPrice
    prod.calculatedMinPrice = priceMounted
    prod.calculatedMinPriceDifferentiated = difPriceMounted
    prod.calculatedFullMinPrice = fullMinPriceMounted
    return Util.formatMoney(difPriceMounted)
}

const initGlobalVariables = function () {
    // showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
    minPrecMutexGroups = {}
    minPrecComboCombo = {}
    priceMounted = 0
    difPriceMounted = 0
    fullMinPriceMounted = 0
}

const treatGroupsMinPrices = function (prod) {
    prod.productGroups.forEach(group => {
        let firstLevelFatherPrint = prod.productPrint === 'S'
        let groupPrint = group.productGroupPrint === 'S'
        let mandatoryGroup = group.productGroupMin > 0

        if ((groupPrint && mandatoryGroup) || !firstLevelFatherPrint) {
            checkForComboDoComboMinPrices(prod, group, firstLevelFatherPrint)
        }

        let result = null

        if ((groupPrint && mandatoryGroup) || !firstLevelFatherPrint) {
            result = getGroupMinPriceItem(group, prod)
            if (result && result.comboTotals && Util.isComboDoCombo(result.minPriceItem, prod.productCode)) {
                applyComboDoComboMutexSideEffectsForKey(result.minPriceItem.subItemCode, prod)
            }
            minPrecComboCombo = {}
        }

        if (!result) return

        const minItem = result.minPriceItem
        if (!minItem) return

        const comboTotals = result.comboTotals
        const productCode = minItem.subItemCode || minItem.productCode
        const diffPrice = (DifferentiatedPricesController.getDiffPrice(productCode, true, minItem))
            || ((minItem.price === 0 && minItem.minPrice != null) ? minItem.minPrice : minItem.price)

        let isMutexGroup = group.productGroupMutex != null

        if (isMutexGroup) {
            insertPriceInMutexObject(group, minItem, diffPrice, comboTotals)
        } else if (comboTotals) {
            priceMounted += comboTotals.normal * group.productGroupMin
            difPriceMounted += comboTotals.diff * group.productGroupMin
            fullMinPriceMounted += comboTotals.full * group.productGroupMin
            insertGroupMinPrice(group, comboTotals.normal, comboTotals.diff, comboTotals.full)
        } else {
            priceMounted += minItem.price * group.productGroupMin
            difPriceMounted += diffPrice * group.productGroupMin
            fullMinPriceMounted += minItem.fullPrice * group.productGroupMin
            let price = (minItem.price === 0 && minItem.minPrice != null)
                ? minItem.minPrice
                : minItem.price

            insertGroupMinPrice(group, price, diffPrice, minItem.fullPrice)
        }
    })
}

const insertPriceInMutexObject = function (group, item, diffPrice, comboTotalsOpt) {
    let entry = comboTotalsOpt
        ? {
            normal: comboTotalsOpt.normal * group.productGroupMin,
            diff: comboTotalsOpt.diff * group.productGroupMin,
            full: comboTotalsOpt.full * group.productGroupMin
        }
        : {
            normal: item.price * group.productGroupMin,
            diff: diffPrice * group.productGroupMin,
            full: item.fullPrice * group.productGroupMin
        }

    if (!minPrecMutexGroups[group.productGroupMutex]) {
        minPrecMutexGroups[group.productGroupMutex] = []
    }

    minPrecMutexGroups[group.productGroupMutex].push(entry)
}

const insertGroupMinPrice = function (group, minPrice, minPriceDifferentiated, fullMinPrice) {
    // Preço mínimo do grupo: item simples (price/minPrice) ou combo-do-combo (totais dos subgrupos em getGroupMinPriceItem)
    group.minPrice = minPrice
    group.minPriceDifferentiated = minPriceDifferentiated
    group.fullMinPrice = fullMinPrice
}

const checkForComboDoComboMinPrices = function (prod, group, firstLevelFatherPrint) {
    // A segunda verificação é uma solução temporária para os produtos chegando errado no cardápio, trazendo o
    // produto inteiro dentro do primeiro subgrupo. Remover assim que o problema for corrigido na Interface
    let groupHasItems = group.productGroupItems && group.productGroupItems.length > 0
    // let isNotInterfaceError = group.productGroupName !== prod.productName
    // aqui é o seguyndo nivel
    if (groupHasItems) {
        let filteredItems = Util.removeBlockedProds(group.productGroupItems)

        filteredItems.forEach(subProd => {
            let comboDoCombo = Util.isComboDoCombo(subProd, prod.productCode)
            if (comboDoCombo) {
                /* quando o item principal for imprime nao, o preço do combo deve ser zerado permanecendo somente o preço dos filhos */
                if (!firstLevelFatherPrint) {
                    subProd.price = 0
                    subProd.fullPrice = 0
                }
                // subProd.price = 0
                // Combo do combo o segundo nivel não deve ser cobrado
                // subProd.subItemProductPrint = 'N'
                /* subProd.price = 0
                subProd.fullPrice = 0 */
                getComboDoComboMinPrices(subProd, firstLevelFatherPrint, group)
            }
        })
    }
}

const getComboDoComboMinPrices = function (subProd, firstLevelFatherPrint, group) {
    let minPriceGrup = 0
    let minPrecSubSubItemFullGrup = 0
    let minPrecSubSubItemDifferentiatedGrup = 0

    subProd.subItemProductGroups.forEach(subGroup => {
        let minPrecSubSubItem = null
        let minPrecSubSubItemDifferentiated = null
        let isRecursive = subGroup.subItemCode === subProd.subItemCode
        let imprimeGrupoSegundoNivel = group.productGroupPrint === 'S'

        if (imprimeGrupoSegundoNivel && firstLevelFatherPrint && !isRecursive) {
            /* Ajustando se o preço no segundo nivel é cobrado. Ajuste no cosechas @TODO verificar com um produto recursivo imprime sim e imprime sim */
            subProd.price = 0
            subProd.fullPrice = 0
        }

        if (subGroup.subProductGroupMin > 0 && ((subGroup.subProductGroupPrint === 'S') || !firstLevelFatherPrint)) {
            // quando o item principal é imprime nao, sempre cobra os filhos, caso contrario valida se é pra cobrar esses itens
            let result = getSubGroupMinPriceItem(subGroup)
            minPrecSubSubItem = result.minPriceItem
            minPrecSubSubItemDifferentiated = result.minPriceItemDifferentiated
        }

        if (minPrecSubSubItemDifferentiated) {
            let isMutexGroup = subGroup.subProductGroupMutex != null
            if (isMutexGroup) {
                minPrecSubSubItemDifferentiated.groupMutexInfo = {
                    mutexKey: subGroup.subProductGroupMutex,
                    groupName: group.productGroupName,
                    subProdName: subProd.subItemName
                }
            }

            insertProdInComboDoComboObject(subProd, minPrecSubSubItem, minPrecSubSubItemDifferentiated)
            // if (showMinPriceDifference) {
            // insertGroupMinPrice(subGroup, minPrecSubSubItem.price, minPrecSubSubItemDifferentiated.price, minPrecSubSubItem.fullPrice)
            let minPrice = minPrecSubSubItem.price * (subGroup.subProductGroupMin || 1)
            minPriceGrup += minPrice
            minPrecSubSubItemDifferentiatedGrup += minPrecSubSubItemDifferentiated.price
            minPrecSubSubItemFullGrup += minPrecSubSubItem.fullPrice

            insertGroupMinPrice(subGroup, minPrice, minPrecSubSubItemDifferentiated.price, minPrecSubSubItem.fullPrice)
            insertGroupMinPrice(subProd, minPrice, minPrecSubSubItemDifferentiated.price, minPrecSubSubItem.fullPrice)
            // }
        }
    })
    insertGroupMinPrice(subProd, minPriceGrup, minPrecSubSubItemDifferentiatedGrup, minPrecSubSubItemFullGrup)
}

const getSubGroupMinPriceItem = function (subGroup) {
    let subGroupHasItems = subGroup && subGroup.subProductGroupItems && subGroup.subProductGroupItems.length > 0
    let subGroupItems = subGroupHasItems ? subGroup.subProductGroupItems : []
    let filteredSubGroupItems = Util.removeBlockedProds(subGroupItems)
    let minPriceItem = null
    let minPriceItemDifferentiated = null
    if (filteredSubGroupItems.length > 0) {
        minPriceItemDifferentiated = filteredSubGroupItems.reduce((a, b) => {
            let productCodeA = a.subItemCode || a.productCode
            let productCodeB = b.subItemCode || b.productCode
            let priceA = DifferentiatedPricesController.getDiffPrice(productCodeA, true, a) || a.price
            let priceB = DifferentiatedPricesController.getDiffPrice(productCodeB, true, b) || b.price
            if (priceB < priceA) a = b
            a.subProductGroupMin = subGroup.subProductGroupMin
            return a
        })
        minPriceItem = filteredSubGroupItems.reduce((a, b) => {
            if (b.price < a.price) a = b
            return a
        })
        if (subGroup.subProductGroupName === 'BEBIDAS') {
            console.log('minPriceItem', minPriceItem)
            console.log('minPriceItemDifferentiated', minPriceItemDifferentiated)
        }
        return {minPriceItem: minPriceItem, minPriceItemDifferentiated: minPriceItemDifferentiated}
    } else {
        return null
    }
}

const insertProdInComboDoComboObject = function (subProd, minPrecSubSubItem, minPrecSubSubItemDifferentiated) {
    if (minPrecComboCombo[subProd.subItemCode]) {
        minPrecComboCombo[subProd.subItemCode].push(minPrecSubSubItem)
    } else {
        minPrecComboCombo[subProd.subItemCode] = []
        minPrecComboCombo[subProd.subItemCode].push(minPrecSubSubItem)
    }
}

const getMutexMinPriceProdForKey = function (mutexGroupsMinPrices, mutexKey) {
    let currentMutexGroup = mutexGroupsMinPrices[mutexKey]
    if (!currentMutexGroup || currentMutexGroup.length === 0) {
        return null
    }
    let currentMutexMinPriceProd = null
    currentMutexGroup.forEach(p => {
        if (!currentMutexMinPriceProd) {
            currentMutexMinPriceProd = p
        } else if (p.price < currentMutexMinPriceProd.price) {
            currentMutexMinPriceProd = p
        }
    })
    return currentMutexMinPriceProd
}

const getMutexTotalsForCombo = function (mutexGroupsMinPrices) {
    let mutexMinPrices = 0
    let mutexMinPricesDifferentiated = 0
    let mutexFullMinPrices = 0
    let mutexKeys = Object.keys(mutexGroupsMinPrices)

    mutexKeys.forEach(mutexKey => {
        let currentMutexMinPriceProd = getMutexMinPriceProdForKey(mutexGroupsMinPrices, mutexKey)
        if (currentMutexMinPriceProd) {
            let productCode = currentMutexMinPriceProd.subItemCode || currentMutexMinPriceProd.productCode
            let differentiatedPrice = DifferentiatedPricesController.getDiffPrice(productCode, true, currentMutexMinPriceProd)
            mutexMinPrices += currentMutexMinPriceProd.price
            mutexMinPricesDifferentiated += differentiatedPrice || currentMutexMinPriceProd.price
            mutexFullMinPrices += currentMutexMinPriceProd.fullPrice
        }
    })

    return { mutexMinPrices: mutexMinPrices, mutexMinPricesDifferentiated: mutexMinPricesDifferentiated, mutexFullMinPrices: mutexFullMinPrices }
}

const getComboDoComboMinTotalsForKey = function (subItemCode, prod) {
    if (!minPrecComboCombo[subItemCode] || minPrecComboCombo[subItemCode].length === 0) {
        return null
    }
    let mutexGroupsMinPrices = {}
    let curMinPrice = 0
    let curMinPriceDifferentiated = 0
    let curFullMinPrice = 0

    minPrecComboCombo[subItemCode].forEach(p => {
        let prodIsFromMutexGroup = p.groupMutexInfo && p.groupMutexInfo.mutexKey != null
        if (prodIsFromMutexGroup) {
            insertIntoMutexObject(mutexGroupsMinPrices, p)
        } else {
            let productCode = p.subItemCode || p.productCode
            curMinPrice += p.price * (p.subProductGroupMin || 1)
            curMinPriceDifferentiated += (DifferentiatedPricesController.getDiffPrice(productCode, true, p) || p.price) * (p.subProductGroupMin || 1)
            curFullMinPrice += p.fullPrice
        }
    })

    if (Object.keys(mutexGroupsMinPrices).length > 0) {
        let result = getMutexTotalsForCombo(mutexGroupsMinPrices)
        curMinPrice += result.mutexMinPrices
        curMinPriceDifferentiated += result.mutexMinPricesDifferentiated
        curFullMinPrice += result.mutexFullMinPrices
    }

    return {
        normal: curMinPrice,
        diff: curMinPriceDifferentiated,
        full: curFullMinPrice
    }
}

const applyComboDoComboMutexSideEffectsForKey = function (subItemCode, prod) {
    if (!minPrecComboCombo[subItemCode] || minPrecComboCombo[subItemCode].length === 0) {
        return
    }
    let mutexGroupsMinPrices = {}
    minPrecComboCombo[subItemCode].forEach(p => {
        let prodIsFromMutexGroup = p.groupMutexInfo && p.groupMutexInfo.mutexKey != null
        if (prodIsFromMutexGroup) {
            insertIntoMutexObject(mutexGroupsMinPrices, p)
        }
    })
    if (Object.keys(mutexGroupsMinPrices).length > 0) {
        getMinPricesFromMutexGroups(mutexGroupsMinPrices, prod)
    }
}

const getGroupMinPriceItem = function (group, prod) {
    let groupItems = group.productGroupItems || []
    let filteredGroupItems = Util.removeBlockedProds(groupItems)

    if (filteredGroupItems.length === 0) {
        return null
    }

    function getEffectiveMinComparePrice (item) {
        if (Util.isComboDoCombo(item, prod.productCode) && minPrecComboCombo[item.subItemCode] && minPrecComboCombo[item.subItemCode].length) {
            let totals = getComboDoComboMinTotalsForKey(item.subItemCode, prod)
            if (totals) {
                return totals.normal
            }
        }
        return item.price === 0 && item.minPrice ? item.minPrice : item.price
    }

    let minPriceItem = filteredGroupItems.reduce((a, b) => {
        return getEffectiveMinComparePrice(b) < getEffectiveMinComparePrice(a) ? b : a
    })

    let comboTotals = null
    if (Util.isComboDoCombo(minPriceItem, prod.productCode) && minPrecComboCombo[minPriceItem.subItemCode]) {
        comboTotals = getComboDoComboMinTotalsForKey(minPriceItem.subItemCode, prod)
    }

    return { minPriceItem: minPriceItem, comboTotals: comboTotals }
}

const insertIntoMutexObject = function (mutexGroupsMinPrices, prod) {
    if (mutexGroupsMinPrices[prod.groupMutexInfo.mutexKey]) {
        mutexGroupsMinPrices[prod.groupMutexInfo.mutexKey].push(prod)
    } else {
        mutexGroupsMinPrices[prod.groupMutexInfo.mutexKey] = []
        mutexGroupsMinPrices[prod.groupMutexInfo.mutexKey].push(prod)
    }
}

const getMinPricesFromMutexGroups = function (mutexGroupsMinPrices, prod) {
    let mutexKeys = Object.keys(mutexGroupsMinPrices)
    let mutexFullMinPrices = 0
    let totals = getMutexTotalsForCombo(mutexGroupsMinPrices)

    mutexKeys.forEach(mutexKey => {
        let currentMutexMinPriceProd = getMutexMinPriceProdForKey(mutexGroupsMinPrices, mutexKey)
        if (currentMutexMinPriceProd) {
            mutexFullMinPrices += currentMutexMinPriceProd.fullPrice
        }
        setComboDoComboMutexMinPrice(currentMutexMinPriceProd, prod, mutexFullMinPrices)
    })

    return totals
}

const setComboDoComboMutexMinPrice = function (mutexMinPriceProd, prod, mutexFullMinPrices) {
    try {
        let productCode = mutexMinPriceProd.subItemCode || mutexMinPriceProd.productCode
        let mutexMinPrice = mutexMinPriceProd.price
        let mutexMinPriceDifferentiated = DifferentiatedPricesController.getDiffPrice(productCode, true, mutexMinPriceProd) || mutexMinPriceProd.price
        let groupMutexInfo = mutexMinPriceProd.groupMutexInfo
        let subProdToApplyMinMutexPrice = null
        let groupToSearch = prod.productGroups.find(group => group.productGroupName === groupMutexInfo.groupName)
        let hasItems = groupToSearch && groupToSearch.productGroupItems != null

        if (hasItems) {
            subProdToApplyMinMutexPrice = groupToSearch.productGroupItems.find(subProd => subProd.subItemName === groupMutexInfo.subProdName)
        }

        let hasSubGroups = subProdToApplyMinMutexPrice && subProdToApplyMinMutexPrice.subItemProductGroups
            && subProdToApplyMinMutexPrice.subItemProductGroups.length > 0

        if (hasSubGroups) {
            subProdToApplyMinMutexPrice.subItemProductGroups.forEach(subGroup => {
                if (subGroup.subProductGroupMutex === groupMutexInfo.mutexKey) {
                    subGroup.minPrice = mutexMinPrice
                    subGroup.minPriceDifferentiated = mutexMinPriceDifferentiated
                    subGroup.fullMinPrice = mutexFullMinPrices
                }
            })
        }
    } catch (error) {
        console.log(error.message)
        Util.logComunication('Exception ', {}, error.message)
    }
}

const treatMutexGroupsMinPrices = function (prod) {
    let mutexKeys = Object.keys(minPrecMutexGroups)

    mutexKeys.forEach(key => {
        let currentMutexGroup = minPrecMutexGroups[key]
        let currentMin = null

        currentMutexGroup.forEach(entry => {
            if (!currentMin) {
                currentMin = entry
            } else if (entry.normal < currentMin.normal) {
                currentMin = entry
            }
        })

        if (currentMin) {
            priceMounted += currentMin.normal
            difPriceMounted += currentMin.diff
            fullMinPriceMounted += currentMin.full

            setMutexGroupsMinPrice(prod, key, currentMin.normal, currentMin.full)
        }
    })
}

const setMutexGroupsMinPrice = function (prod, mutexKey, mutexMinPrice, mutexFullMinPrice) {
    let groups = prod.productGroups || []

    groups.forEach(group => {
        if (group.productGroupMutex === mutexKey) {
            let productGroupMin = group.productGroupMin || 1

            group.minPrice = mutexMinPrice / productGroupMin
            group.minPriceDifferentiated = mutexMinPrice / productGroupMin
            group.fullMinPrice = mutexFullMinPrice / productGroupMin
        }
    })
}

export default {
    getMinPrice: getMinPrice,
    setRecalculatedMinPrice: function (consumerKey) {
        recalculateMinPrice = consumerKey
    }
}



// WEBPACK FOOTER //
// ./src/assets/controllers/MinPriceController.js